import { Component, OnInit, OnDestroy } from "@angular/core";
import Swal from "sweetalert2";
import { Router } from "@angular/router";
import { TranslateService } from '@ngx-translate/core';
import { JobService } from "src/app/shared/API-Service/services/job.service";
import { Subscription } from "rxjs";
import { BaseComponent } from "src/app/shared/components/base/base.component";

@Component({
  selector: 'app-list-job',
  templateUrl: './list-job.component.html',
  styleUrls: ['./list-job.component.css']
})
export class ListJobComponent  extends BaseComponent implements OnInit, OnDestroy {
  public response: any;
  private subscription = new Subscription();

  constructor(private _JobService: JobService, private _router: Router, private _transition: TranslateService
  ) { super() }

  ngOnInit(): void {
    this.Get();
  }

  public track(index, item) {
    return item.id;
  }

  private Get() {
    this.subscription.add(this._JobService.Get(this.pager).subscribe((res) => {
      if (res !== null) {
        this.response = res.data['items'];
        this.totalCount = res.data['totalCount'];
      }
    }));
  }

public  pageChanged(event: any) {
  this.pageNumber = event.page;// -1 * pageSize;
    this.pager.skipCount = (this.pageNumber - 1) * this.pager.maxResultCount;
    this.Get();

  }
public  Delete(id: number) {
    Swal.fire({
      title: this._transition.instant('warning'),
      text: this._transition.instant('Are you sure to delete this file'),
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#F00",
      cancelButtonColor: "#d33",
      confirmButtonText: this._transition.instant('Delete'),
      cancelButtonText: this._transition.instant('Back'),
    }).then((result) => {
      if (result.isConfirmed) {
        this.subscription.add(this._JobService.Delete(id).subscribe(
          (res) => {
            if (res.success === true) {this.Get();
              Swal.fire({
                icon: "success",
                title: this._transition.instant('The employee has been deleted successfully'),  showConfirmButton: false,
                timer: 1500,
              });
            }
          })
        );
      }
    });
  }

public  Update(id) {
    this._router.navigate([`/content/admin/update-Job/${id}`]);
  }
  ngOnDestroy(): void {
    this.subscription.unsubscribe()
  }
}
